import LoadingBar from 'react-redux-loading-bar';

const Loading = () => (
  <LoadingBar className="bg-[#F48023] h-1 absolute top-0 z-50" />
);
export default Loading;
